import React, { useEffect, useState, useRef } from 'react';
import EmployeeForm from './EmployeeForm'; // Adjust path to your EmployeeForm component
import employeeServices from '../employeeServices'; // Adjust path to your employee services
import { useAlert } from '../../../../../context/AlertContext';

import { Autocomplete, TextField, createFilterOptions } from '@mui/material';
import { PublishedWithChanges } from '@mui/icons-material';
import { useAppData } from '../../../../../context/AppDataContext';

const filterOptions = createFilterOptions({
  matchFrom: 'any',
  stringify: (option) => `${option.label} ${option.phone || ''}`,
});

function SelectEmployee({ employee, setEmployee, employeeId }) {

  const focusInputRef = useRef(null);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      if (focusInputRef.current) {
        focusInputRef.current.focus();
      }
    }, 100); // Gives the modal/dropdown animation a brief moment to settle

    return () => clearTimeout(timer);
  }, []);

  const { employeeDD } =useAppData();
  const { AppAlert } = useAlert();

  const getEmployeeDetails = (id) => {
    console.log("get Employee details");
    employeeServices.getById(id).then(res => {
      if (res && res.data) {
        setEmployee(res.data);
      }
    }).catch(error => {
      console.log(error);
      AppAlert("Failed to fetch employee details", "error");
    });
  };

  useEffect(() => {
    if (employeeId) {
      getEmployeeDetails(employeeId);
    }
  }, [employeeId]);

  return (
    <>
      {
        employee ?
          <div className='row'>
              <div className='col-md-12 mb-3'>
                  <div className="input-group">
                      <span className="input-group-text">Selected Employee</span>
                      <input type='text' className='form-control' value={employee.employeeName || ''} readOnly />
                      <button className='btn btn-outline-secondary' onClick={() => setEmployee(null)} type="button" title="Change Employee">
                          <PublishedWithChanges/>
                      </button>
                  </div>
              </div>
          </div>
          :
          <div className='row align-items-center'>
            <div className='col-md-7'>
              <Autocomplete
                  options={employeeDD}
                  filterOptions={filterOptions}
                  getOptionKey={(option) => option.value}
                  onChange={(event, newValue) => {
                      if (newValue) {
                          getEmployeeDetails(newValue.value);
                      }
                  }}
                  className='bg-white'
                  renderInput={(params) => (
                      <TextField inputRef={focusInputRef} {...params} size="small" label='Select Employee' />
                  )} 
              />
            </div>
            <div className='col-md-5'>
              <span className="me-2 text-muted">OR</span>
              <span>
                <EmployeeForm callBackWithId={getEmployeeDetails} />
              </span>
            </div>
          </div>
      }
    </>
  );
}

export default SelectEmployee;